import { render } from "./RedirectApp.vue?vue&type=template&id=473a639c&ts=true"
import script from "./RedirectApp.vue?vue&type=script&lang=ts"
export * from "./RedirectApp.vue?vue&type=script&lang=ts"

import "./RedirectApp.vue?vue&type=style&index=0&id=473a639c&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__